module.exports = __webpack_public_path__ + "static/media/icons.faff9214.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/icons.woff
// module id = ./src/styling/theme/assets/fonts/icons.woff
// module chunks = 0